module.exports = __webpack_public_path__ + "img/collection.4d3e9f57.svg";